module.exports = __webpack_public_path__ + "static/media/Surprise.9d798a04.png";